import React from 'react';

const WarningIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-warning" />
    </div>
  );
};

export default WarningIcon;
